// UltrasonicSensor.jsx
import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { FaFilePdf,FaChevronRight,FaEnvelope } from 'react-icons/fa';
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';

import ultrasonicSpecsImg from '../assets/Ultrasonic Sensor Specification IMG.png';

import '../styles/UltrasonicSensor.css';

import UltrasonicSensorSpecificationPdf from '../assets/Ultrasonic Sensor Specification.pdf'
import ultrasonicPdf from '../assets/ultrasonic.pdf'
import ultrasonicMain from '../assets/ultrasonic_main.png';
import ultrasonic1 from '../assets/ultrasonic1.jpg';
import ultrasonic2 from '../assets/ultrasonic2.jpg';
import ultrasonic3 from '../assets/ultrasonic3.jpg';
import ultrasonic4 from '../assets/ultrasonic4.jpg';



import UltrasonicCylindricalTypePdf from '../assets/Ultrasonic/Ultrasonic Cylindrical Type.pdf'
import UltrasonicSolidLevelSwitchPdf from '../assets/Ultrasonic/Ultrasonic Solid Level Switch.pdf'
import UltrasonicForkTypeLiquidLevelSwitchPdf from '../assets/Ultrasonic/Ultrasonic Fork Type Liquid Level Switch.pdf'
import UltrasonicDoubleSheetDetectionSensorPdf from '../assets/Ultrasonic/Ultrasonic Double Sheet Detection Sensor.pdf'

export default function UltrasonicSensor() {

  const [activeTab, setActiveTab] = useState('products');
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="UltrasonicSensor-wrapper">
      <Header />

      <div className="hero-banner18">
        <div className="hero-banner18-content">
          <h1>ULTRASONIC SENSOR</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Ultrasonic Sensor</span>
          </div>
        </div>
      </div>

      <section className="sensor-intro-wrap">
        <img src={ultrasonicMain} alt="Ultrasonic Sensor" />
        <div className="sensor-description">
          <h2>Ultrasonic Sensor</h2>
          <ul>
            <li>An all-rounder with a wide range of objects</li>
            <li>Measuring distance up to 6m, millimeter accuracy</li>
            <li>It can adapt to a variety of harsh environments, such as high temperature, dust, water mist.</li>
            <li>Can be used to solve even the most complex tasks involving object detection or level measurement with millimeter precision.</li>
          </ul>
          <div className="sensor-buttons">
            <a href={ultrasonicPdf}  target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Full Catalog Download</button></a>
          <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

          </div>
        </div>
      </section>

<div className="sensor-tabs">
  
  <button
    className={activeTab === 'products' ? 'active' : ''}
    onClick={() => setActiveTab('products')}
  >
    Ultrasonic Sensor Products
  </button>
  <button
    className={activeTab === 'specs' ? 'active' : ''}
    onClick={() => setActiveTab('specs')}
  >
    Technical Specifications
  </button>
</div>

      <section className="sensor-product-section">
{activeTab === 'specs' && (
  <div className="UltrasonicSensorSpecs-image-wrapper">
    <img
      src={ultrasonicSpecsImg} // Replace with actual image if you have
      alt="Ultrasonic Sensor Technical Specifications"
      className="UltrasonicSensorSpecs-img"
    />
    <div className="UltrasonicSensorSpecs-download-btn">
      <a href={UltrasonicSensorSpecificationPdf} target="_blank" rel="noopener noreferrer">
        <button className="download-catalog-btn">
          <FaFilePdf style={{ marginRight: '8px' }} /> Download
        </button>
      </a>
    </div>
  </div>
)}

{activeTab === 'products' && (
        <div className="sensor-product-grid">
          <div className="sensor-card">
            <img src={ultrasonic1} alt="Cylindrical Type" />
            <h4>Cylindrical Type</h4>
            <ul>
              <li>Sizes of M18 and M30</li>
              <li>Sensing distance 40–6000mm</li>
              <li>PNP/NPN/Analog output</li>
            </ul>
            <a href={UltrasonicCylindricalTypePdf}  target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a>
          </div>
          <div className="sensor-card">
            <img src={ultrasonic2} alt="Solid Level Switch" />
            <h4>Solid Level Switch</h4>
            <ul>
              <li>Detects water, oil, solvent, reagents</li>
              <li>2mm position repeatability</li>
              <li>Integrated relay output</li>
            </ul>
            <a href={UltrasonicSolidLevelSwitchPdf}  target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a>
          </div>
          <div className="sensor-card">
            <img src={ultrasonic3} alt="Fork Type Liquid Level Switch" />
            <h4>Fork Type Liquid Level Switch</h4>
            <ul>
              <li>Detects all kinds of liquid</li>
              <li>Works under high pressure</li>
              <li>Digital filtering tech</li>
            </ul>
            <a href={UltrasonicForkTypeLiquidLevelSwitchPdf}  target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a>
          </div>
          <div className="sensor-card">
            <img src={ultrasonic4} alt="Double Sheet Detection Sensor" />
            <h4>Double Sheet Detection Sensor</h4>
            <ul>
              <li>Detects single & double sheets</li>
              <li>Teach-in function</li>
              <li>Stable for paper, plastic, metal</li>
            </ul>
            <a href={UltrasonicDoubleSheetDetectionSensorPdf}  target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a>
          </div>
            

        </div>

)}
      </section>

      <Footer />
    </div>
  );
}
